module.exports = __webpack_public_path__ + "static/media/early4.6334d39a.JPG";